import { LendOutRequestCollection, LendOutRequestCollectionToJSON } from '@/api'

export interface LendOutRequest {
  userId: string
  collections: LendOutRequestCollection[]
  isReading: boolean
  isPrint: boolean
  lendMynumbercard: boolean
}

export const defaultLendOutRequest = (): LendOutRequest => ({
  userId: '',
  collections: [],
  isReading: false,
  isPrint: true,
  lendMynumbercard: false
})

export function LendOutRequestToJSON(value: LendOutRequest): any {
  return {
    user_id: value.userId !== '' ? value.userId : undefined,
    collections:
      value.collections.length > 0
        ? value.collections.map(LendOutRequestCollectionToJSON)
        : undefined,
    is_reading: value.isReading ?? undefined,
    is_print: value.isPrint ?? true,
    lend_mynumbercard: value.lendMynumbercard ?? undefined
  }
}
